<template>
<section>
        <div class="container-fluid">
            <div class="row">
	        	<div class="col-12">
		        	<div class="h3 pb-2 black uppercase  mb-4">Reports</div>
	        	</div><!--col-->
            </div><!--row-->
            <div class="row">
	        	<div class="col-6 col-xl-6">
					<form class="form-background-color" @submit.prevent="onSubmit">
					<div class="form-group d-flex">
						<div class="input-content input-content-horizontal">
							<label class="label-border">Program Name</label>
							<v-select :searchable="true" track-by="value" label="label" :options="courses" name="program_name" v-validate="'required'" v-model="report_section.programs" class="v-select-no-height" multiple>
							</v-select>
							<span class="input-error-msg">{{ errors.first('program_name') }}</span>
						</div>
					</div>
					<div class="form-group d-flex">
						<div class="border-input">
							<label class="label-border">Completed</label>
						</div>
						<div class="radio-group-input">
							<input v-validate="'required|included:course,module,lesson'" name="radio-group" type="radio" class="" id="Program" value="course" v-model="report_section.completed">
							<label for="Program">Program</label>
							<input name="radio-group" type="radio"  class=" ml-2" id="Module" value="module" 
							v-model="report_section.completed">
							<label for="Module" >Module</label>
							<input type="radio" name="radio-group" class=" ml-2" id="Lesson" value="lesson" 
							v-model="report_section.completed">
							<label for="Lesson" >Lesson</label>
							<span class="input-radio-err" v-show="errors.has('radio-group')">Completed required</span>
						</div>
					</div>
					<div class="form-group d-flex align-items-center">
						<div class="border-input">
							<label class="label-border">Aggregated results</label>
						</div>
						<div class="radio-group-input mb-2">
						<v-select :options="aggregated_result_options" v-validate="'required'"  name="radio-group-aggreated" v-model="report_section.aggregated_result" class="green min-width-200 "></v-select>
							<span class="input-radio-err" v-show="errors.has('radio-group-aggreated')">Aggregated result required</span>
						</div>
					</div>
					<div class="mb-3">
						<date-picker range :format="'MM-DD-YYYY'" :disabled="all_date_choosen" v-model="report_section.date"
						:placeholder="date_picker_placeholder" :range-separator="' to '" @input="dateChanged()"
						:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
						:valueType="'YYYY-MM-DD'"></date-picker>
										
						<button type="button" @click="changeDateSelection" class="button">{{date_all_text}}</button>

					</div>
					<div class="form-group">
						<button type="submit" v-if="user_meta_actions.includes('run_reports')" class="button" :class="{'input-disabled': !form_valid}" :disabled="!form_valid"><img width="11" src="../../../assets/images/icons/solid/clipboard-list_white.svg"> Generate report</button>
					</div>
					</form>
	        	</div>
            </div> 
		
            <div class="row">
	        	<div class="col-12 col-xl-12 mt-2">
					<!-- <button type="button"  class="button float-right" @click="getCourses()"><img width="11" src="../../../assets/images/icons/solid/redo_white.svg"> Reload Reports</button> -->
		        	<div class="bold pb-2 black text-uppercase  mb-2">Reports History</div>
					
		        	<div class="p-3 lightgray-content">
			        	<ul class="table-list  list-unstyled">
				        	<li class="mb-2 pb-2 border-bottom mt-2" v-for="(course, index) in existing_reports" :key="index">
			                	<div class="d-flex align-items-center justify-content-between">
				                	<div class="d-flex">
					                	<div class="caption min-width-250">
						                	<div class="title">{{ course.params.name }} </div>
						                	<div class="subtitle">Report Created on {{ course.created_at }}</div>
						                	<!-- <div class="subtitle"></div> -->
					                	</div>
					                	<div class="caption ml-3">
						                	<div class="title">Date Range</div>
											<div v-if="course.params.completion_from_date == null">
												All Dates
											</div>
											<div v-else>
												<div class="subtitle">From {{ course.params.completion_from_date }}</div>
												<div class="subtitle">To {{ course.params.completion_to_date }}</div>
											</div>
						                
					                	</div>
					                	<div class="caption ml-3">
						                	<div class="title">Completed By</div>
						                	<div class="subtitle">{{ comptetionString(course.params.completion_type) }}</div>
					                	</div>
					                	<div class="caption ml-3">
						                	<div class="title">Aggregated results</div>
						                	<div class="subtitle">{{ course.params.aggregated==1?'Yes':'No' }}</div>
					                	</div>
				                	</div>
				                	
				                	<div class="text-right">
					                	<a :href="course.report_download_url" v-if="course.report_download_url" class="button">
						                	<img width="14" src="../../../assets/images/icons/solid/download_white.svg"> Download xls
					                	</a>

					                	<a :href="course.report_download_pdf_url" v-if="false" class="button">
						                	<img width="14" src="../../../assets/images/icons/solid/download_white.svg"> Download pdf
					                	</a>
					                	
					                	<button type="button"  class="button" @click="downloadReport(course.url)"><img width="11" src="../../../assets/images/icons/solid/clipboard-list_white.svg"> Download report</button>
				                	</div>
			                	</div>
				            </li>
			        	</ul>
		        	</div>
	        	</div><!--col-->
	        </div><!--row-->
	        
	        
	        <div class="row">
	        	<div class="col-12 col-xl-12">
		        	<div class="bold pb-2 black text-uppercase  mb-2">Hours learned - "Payroll report"</div>
	                	<div class="d-flex align-items-center justify-content-between">
		                	<div class="d-flex">
								<p style="max-width:70%;">Note: This report shows employees that have completed their program only. For the range of dates you will choose, you will get a report of all employees that have completed their program in that range and the hours they have learned. If the employee completed more than one program, each program will be shown in a different line.</p>
							</div>
				            <div class="text-right">
								<button type="button" v-if="user_meta_actions.includes('run_reports')" class="button" @click="openModalGenerateByDate()" style="width:160px;"><img width="11" src="../../../assets/images/icons/solid/clipboard-list_white.svg"> Generate report</button>
							</div>
						</div>
	        		</div>
	        	</div>
	        </div>
	        
        </div>

        <b-modal v-model="show_generate_report_dates" title="Generate report by date"  @ok="downloadReportByDate" cancel-title="Cancel" ok-title="Generate">
	    	<div >
				<p class="mb-2">

					<p>Generate report for {{ course_name_by_date }}</p>

					<div class="form-group input-content">
						<label>From</label>
						
						<datetime  v-model="from"  placeholder="From" ></datetime>
					</div>
					<div class="form-group input-content">
						<label>To</label>
						
						<datetime  v-model="to" placeholder="To" ></datetime>
					</div>
				</p>
			</div>
		</b-modal>

    </section>
</template>

<script>
export default {
	components : {
		
	},
	props:{
		page_loading:{
			required: false,
			default: true
		},
		organization_id:{
			required: false
		}
	},
    data() {
        return {
	        courses : [],
			report_section:{
				programs:[],
				completed:'course',
				date:'',
				aggregated_result: {label: 'Aggregate per user', key: 1},
				completion_from_date:'',
				completion_to_date:''

			},
			show_generate_report_dates : false,
			from : null,
			to : null,
			course_name_by_date : '',
			course_id_by_date : null,
			temp_current_org: this.$store.getters.getCurrentOrganization,
			user_meta_actions: localStorage.getItem('meta_actions'),
			date_picker_placeholder: 'Pick a date',
			date_all_text: 'All',
			all_date_choosen: false,
			form_valid: false,
			download_token: this.$store.getters.getDownloadToken,
			existing_reports:'',
			aggregated_result_options:[
				{label: 'Aggregate per user', key: 1},
				{label: 'Aggregate per day per user', key:2},
				{label: 'No', key: 0}
			]
        }
    },
	computed:{
		get_current_org: function(){
			return this.$store.getters.getCurrentOrganization
		},
		form_input_validation: function(){
			if(this.report_section.programs.length == 0 ||this.report_section.completed == '' || this.report_section.aggregated_result == '' || this.report_section.aggregated_result == null){
				return false
			}else{
				return true
			}
		}
	},
	watch:{
		'report_section.programs': function(val){
			//if All is added last, we remove everything but All
			let temp_first_val = val.at(-1)
			if(temp_first_val.id == 'all' && val.length > 1){
				this.report_section.programs = []
				this.report_section.programs.push({value:'all', label:'All'})
				return
			}
			//if All is first option, remove all
			if(val[0].id == 'all' && val.length > 1){
				this.report_section.programs.shift()
				return
			}
		},
		report_section: {
			handler(val){
				if(!this.form_input_validation){
					this.form_valid = false
				}else{
					if(this.all_date_choosen){
						this.form_valid = true
					}else{
						this.checkDateArray(val.date)
					}
				}
			},
			deep: true
		},
		all_date_choosen: function(val){
			if(val){
				this.date_all_text = 'Manual Select'
				this.date_picker_placeholder = 'All Dates Covered'
			}else{
				this.date_picker_placeholder = 'Pick a date'
				this.date_all_text = 'All'
			}
		},
		get_current_org: function(val){
			if(val == this.temp_current_org){
				return
			}else{
				this.temp_current_org = val
				this.getCourses();
				this.getDownloadedReports()
			}
		},
	},
	created : function(){
		this.getCourses();
		this.getDownloadedReports()
	},
    methods: {
		onSubmit: function(){
			this.$validator.validateAll().then((result) => {
				var params = {
					filters : {
						course_ids:this.report_section.programs.map(elem =>elem.value),
						completion_type: this.report_section.completed,
						aggregated: this.report_section.aggregated_result.key,
						download_token: this.download_token,

					}
				}
				if(this.organization_id){
					params.filters.organization_id = this.organization_id
				}
				if(this.report_section.date != ''){
					params.filters.completion_from_date = this.report_section.date[0]
					params.filters.completion_to_date = this.report_section.date[1]
				}else{
					params.filters.completion_from_date = ''
					params.filters.completion_to_date = ''
				}

				this.$store.dispatch('generateCourseReport', params).then((res) => {
					this.downloadCSV(res)
					this.getDownloadedReports()

				}).catch((error) => {
					console.log(error.response);
				});
				
			});

		},
		getDownloadedReports: function(){
			var params = {
				filters : {
					download_token: this.download_token,
					page_loading: this.page_loading
				}
			}
			if(this.organization_id){
				params.filters.organization_id = this.organization_id
				params.filters.page_loading = false
			}
			this.$store.dispatch('generateCourseReportDownloads', params).then((res) => {
				this.existing_reports = res.data.data.reverse()
			}).catch((error) => {
				console.log(error.response);
			});


		},
		downloadCSV: function(res){
			var csvReport = document.createElement('a');
			csvReport.href = 'data:text/csv;charset=utf-8,' + encodeURI(res.data);
			csvReport.target = '_blank';
			csvReport.download = res.headers['content-disposition'].split('filename=')[1].split(';')[0];
			csvReport.click();
		},

		getCourses : function(){
			var params = {
				filters : {
					page : this.current_page,
					has_provider: 1,
					to_select: true,
					published: true,
					has_provider: 1
				},

			}
			if(this.$route.params && this.$route.params.agency_id){
				params.filters.only_organization = 1
				params.filters.in_organization = this.$route.params.agency_id
			}
			
			this.$store.dispatch('getCourses', params).then((res) => {
				this.courses = res.data.data;
				this.courses.unshift({value:'all', label:'All'})
			
			}).catch((error) => {
				console.log(error);
			});
		},
		downloadReport(url){
			window.location.href = url;

		},
		comptetionString(type){
			return type == 'course' ?  'program' : type
		},
		// generateReport : function(course_id){
	
		// 	var params = {
		// 		id : course_id,
		// 		filters : {}
		// 	}

		// 	this.$store.dispatch('generateCourseReport', params).then((res) => {
		// 		setTimeout( () => {this.getCourses()},2000)
		// 	}).catch((error) => {
		// 		console.log(error.response);
		// 	});
		// },
		openModalGenerateByDate : function(){
			this.from = null;
			this.to = null;
			this.show_generate_report_dates = !this.show_generate_report_dates;
		},

		downloadReportByDate(){
			var params = {
				id : this.course_id_by_date,
				filters : {
					start_date : this.from,
					end_date : this.to
				}
			}


			this.$store.dispatch('generateCourseReportByDate', params).then((res) => {
				window.location.href=res.data.url;
			}).catch((error) => {
				console.log(error.response);
			})
		},
		changeDateSelection: function(){
			this.report_section.date = ''
			this.all_date_choosen = !this.all_date_choosen
			if(this.form_input_validation){
				if(this.all_date_choosen){
					this.form_valid = true
				}else{
					if(Array.isArray(this.report_section.date)){
						this.form_valid = true
					}else{
						this.form_valid = false
					}
				}
			}

		},
		dateChanged: function(){
			if(this.form_input_validation){
				if(this.all_date_choosen){
					this.form_valid = true
				}else{
					this.checkDateArray(this.report_section.date)
				}
			}
		},
		checkDateArray: function(val){
			if(Array.isArray(this.report_section.date)){
				if(this.report_section.date[0] == null){
					this.form_valid = false
				}else{
					this.form_valid = true
				}
			}else{
				this.form_valid = false
			}
		}
    }
};


</script>
<style>
.min-width-250{
	min-width: 250px !important;
}
.form-background-color{
	background-color: #f5f5f5;
	padding:4px;
	border-radius: 4px;
}
.label-border{
	padding: 0px 2px 0px 2px;
	height:30px;
	min-width:150px;
	margin-right: 5vh;
	padding-top: 0.2em;
}
.form-group .border-input{
	height:30px;
	width:auto;
	/* margin-right: 5vh; */
	text-align: left;
	align-items: center;
}
.form-group label:first-child{
	margin-top: 3%;
	font-size: 15px;
	font-weight: 700;
}
.radio-group-input{
	position: relative;
}
.form-group .radio-group-input{
	padding-top: 8px;
}
.radio-group-input label{
	font-size: 15px;
}
.font-size-checkbox{
	font-size: 15px;
	width: auto;
}
.align-items-center{
	align-items: center
}
.mx-input-wrapper input{
	/* border-bottom: none; */
	background-color:white;
	padding: 15px;
	border-radius: 4px;
	color:  #11a5a7;
}
.height-20{
	height: 20px;
}
.radio-group-input .input-radio-err{
	position: absolute;
    top: calc(100% + 1px);
    right: 0;
    background: #b76b72;
    color: #fff;
    font-size: 0.6rem;
    z-index: 1;
    line-height: 2;
    border-radius: 0 0 3px 3px;
    padding: 0 6px;
}
@media screen and (max-width:767px) {
	
	.border-input{
		width: 100%;
		
	}
	.radio-group-input{
		width: 100%;

	}
}

</style>


// WEBPACK FOOTER //
// src/components/organizations/reports/OrganizationReportListComponent.vue